import './main.module';


// WEBPACK FOOTER //
// src/public/entry.js